import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api/types';

/** 401 nunca merece retry automático (sessão morta é sessão morta); os demais
 * erros de rede têm uma tentativa extra — o BFF já é fail-closed, não precisamos
 * mascarar timeouts reais com retry agressivo. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        if (error instanceof ApiError && (error.status === 401 || error.status === 403)) {
          return false;
        }
        return failureCount < 1;
      },
      staleTime: 10_000,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});

export const queryKeys = {
  session: ['session'] as const,
  envelopes: (status?: string) => ['envelopes', status ?? 'all'] as const,
  envelope: (id: string) => ['envelope', id] as const,
  evidence: (id: string) => ['evidence', id] as const,
  /** `GET /web/dashboard` (R-UX02-P01/L3B) — chave PRÓPRIA, independente de
   * `envelopes` acima: invalidar a lista nunca deve invalidar (nem confundir
   * com) o read model da Home, e vice-versa. São dois endpoints diferentes. */
  dashboard: ['dashboard'] as const,
};
